import api from '@/api'

const getCashRegisters = function (org_id, params) {
    // let params={
    //   search: '',
    //   limit: 10,
    //   offset:0,
    // }
    return api.get(`/organizations/${org_id}/cash-registers`,{params})
}
const getCashRegisterById = function (org_id, kkt_id) {
    return api.get(`/organizations/${org_id}/cash-registers/${kkt_id}`)
}


export default {
 getCashRegisters,
  getCashRegisterById
}
